/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Enter at least {minimumLength} characters or digits to search all {sourceName} records.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'No results found',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Check results from other sources or change your keyword.',
  [HintsType.searching]: 'Searching...',
  companyTabTitle: 'Company',
  personalTabTitle: 'Personal',
  direct: 'Direct',
  extension: 'Ext.',
  contact: 'Contact',
  mobile: 'Mobile',
  company: 'Company',
  home: 'Home',
  home2: 'Home',
  other: 'Other',
  business: 'Business',
  business2: 'Business',
  car: 'Car',
  fax: 'Fax',
  assistant: 'Assistant',
  callback: 'Callback',
  MobileNumber: 'Mobile number',
  ContactNumber: 'Contact number',
  DirectNumber: 'Direct number',
  doNotCall: 'Do Not Call',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
